import React from "react";

export default ({ tableId, message, colSpan }) => (
  <tr>
    <td id={`${tableId}-message`} colSpan={colSpan} className="text-center">
      {message}
    </td>
  </tr>
);



// WEBPACK FOOTER //
// ./src/sc/ui/components/NoRecords.js